

















































































import {
  defineComponent, computed, ref, onMounted,
} from '@vue/composition-api';
import type { PropType } from '@vue/composition-api';
import type {
  Contract,
} from '@/api/contract/types';
import { CommodityPo } from '@/po/commodity';
import platform from '@/shared/utils/platform';
import { formatContractName, getContractIframeUrl } from '@/views_v2/pre-apply-choose/utils';
import { Checkbox } from '@hb/coffee';

export default defineComponent({
  components: {
    Checkbox,
  },
  props: {
    channelList: {
      type: Array as PropType<CommodityPo.Info[]>,
      default: () => [],
    },
    isDcHalfApply: {
      type: Boolean,
      default: false,
    },
    isParallel: {
      type: Boolean,
      default: false,
    },
  },
  emits: [
    'changeSelect',
    'changeContract',
  ],
  setup(props, context) {
    const contentData = ref();

    const topContractDes = computed(() => {
      const { isDcHalfApply, isParallel } = props;
      if (isDcHalfApply) {
        return '*以下产品均由第三方提供，臻有钱仅提供信息展示';
      }
      if (isParallel) {
      // 并行阅读协议文案
        return '我们安排以下资方为您提供额度，越多的资方意味着可能获得越高的额度，必要时您可主动选择资方。为更好的提供服务，将同时为您发起申请。';
      }
      // 串行阅读协议文案
      return '以下资方将为您提供额度，为提供更好的服务，若其中任何一家审批通过，则不再向其余机构提交申请，请在申请前阅读并同意第三方贷款机构的相关协议。';
    });
    // 取消 / 选中渠道
    const selectChannel = (channel: CommodityPo.Info) => {
      channel.isSelected = !channel.isSelected;
      context.emit('changeSelect', channel.commodityId);
    };

    /** 协议切换 */
    const changeContractIndex = (
      channel: CommodityPo.Info,
      index: number,
      contract: Contract, event:Event,
    ) => {
      event.preventDefault();
      event.stopPropagation();
      channel.contractActive = index;
      context.emit('changeContract', channel, contract);
    };
    const getIframeUrl = (channel: CommodityPo.Info) => {
      const { contractList = [] } = channel;
      if (contractList.length === 0) {
        return '';
      }
      const url = contractList[channel.contractActive || 0].url || '';
      return getContractIframeUrl(channel.commodityId, url);
    };

    onMounted(() => {
      /** 对数据进行预处理 */
      const { channelList } = props;
      contentData.value = channelList.map((channel) => ({
        ...channel,
        isExpand: false, // 添加默认展开状态
        contractActive: 0,
      }));
      // 只有一个授信渠道时默认展开
      if (channelList.length === 1) {
        contentData.value[0].isExpand = true;
      }
    });

    const expandChannel = (channel: CommodityPo.Info, e:Event) => {
      e.preventDefault();
      e.stopPropagation();

      channel.isExpand = true;
    };
    return {
      platform,
      topContractDes,
      contentData,
      selectChannel,
      changeContractIndex,
      getIframeUrl,
      expandChannel,
      formatContractName,
    };
  },
});
